export default "__VITE_ASSET__8b170467__"